import { constants } from "shared/forms/LogInteraction/constants"

import type { FieldError, UseFormSetError } from "react-hook-form"
import type { FormValues } from "@/pages/log-interaction/types"

type SetParticipantsErrorsArgs = {
    hasAtLeastTwoParticipants: boolean
    errors?: FieldError
    setError: UseFormSetError<FormValues & { participants?: unknown }>
}

export const PARTICIPANTS_KEY = "participants"

export const setParticipantsErrors = ({ hasAtLeastTwoParticipants, errors, setError }: SetParticipantsErrorsArgs) => {
    const hasAtLeastTwoParticipantsErrorSet = hasAtLeastTwoParticipants
        ? !errors?.types?.hasAtLeastTwoParticipants
        : errors?.types?.hasAtLeastTwoParticipants
    const isErrorAlreadySet = hasAtLeastTwoParticipantsErrorSet

    if (isErrorAlreadySet) {
        return
    }

    setError(PARTICIPANTS_KEY, {
        type: "custom",
        types: {
            ...(!hasAtLeastTwoParticipants && {
                hasAtLeastTwoParticipants: constants.minimumParticipantsError,
            }),
        },
    })
}
